<template>
  <ais-refinement-list :attribute="attribute">
    <div
      class="dropdown-selector ml-4"
      ref="container"
      slot-scope="{
        items,
        isShowingMore,
        isFromSearch,
        canToggleShowMore,
        refine,
      }"z
    >
      <div
        :class="['flex-1 filter-btn', isOpen || hasSelectedItems(items) ? 'filter-btn--gold' : '']"
        @click="toggle()"
        id="dropdown"
      >
        <span>{{ name }}</span>
        <i :class="['fas', isOpen ? 'fa-caret-up' : 'fa-caret-down', 'ml-4']" />
      </div>
      <div
        v-if="isOpen"
        :class="['overlay', `overlay--${sideDropdown}`]"
      >
        <div class="overlay-top">
          <div
            class="flex-1 self-stretch simple-btn btn-white btn-ghost border text-sm font-normal py-0"
            @click="clear(items, refine)"
          >
            Clear
          </div>
        </div>
        <div class="item-list">
          <div
            v-for="item in items"
            :key="item.value"
            @click.prevent="refine(item.value)"
            :class="['item', item.isRefined && 'item--selected']"
          >
            {{ item.value }} ({{ item.count.toLocaleString() }})
          </div>
        </div>
      </div>
    </div>
  </ais-refinement-list>
</template>

<script>
import { closeOnOutsideClickMixin } from '../../../shared/mixins/closeOnOutsideClickMixin';

export default {
  mixins: [closeOnOutsideClickMixin],

  props: {
    attribute: String,
    name: String,
    side: {
      type: String,
      default: 'right',
    },
  },

  data() {
    return {
      isOpen: false,
      sideDropdown: this.side,
    };
  },

  methods: {
    toggle() {
      // Make sure we dont open the dropdown outside the screen especially on mobile
      const dropdownRect = document.getElementById('dropdown').getBoundingClientRect();

      if (window.innerWidth - dropdownRect.right > dropdownRect.left) {
        // More space on the right
        this.sideDropdown = 'right'
      } else {
        // More space on the left or equal
        this.sideDropdown = 'left'
      }

      this.isOpen ? this.close() : this.open();
    },

    open() {
      this.isOpen = true;
      this.listenForOutsideClicks();
    },

    close() {
      this.isOpen = false;
      this.stopListeningForOutsideClicks();
    },

    clear(items, refine) {
      this.isOpen = false;
      items.filter(item => item.isRefined).forEach(item => refine(item.value));
    },

    hasSelectedItems(items) {
      return items.some(item => item.isRefined);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-selector {
  @apply relative select-none;
  @apply flex flex-col h-full;
}

.overlay {
  @apply mt-2;
  @apply bg-10 border border-honestly-white;
  @apply text-honestly-white text-left;
  @apply whitespace-nowrap;
  @apply flex flex-col;
  @apply shadow-md;
  @apply absolute z-50;
  top: 100%;
  min-width: 200px;

  &--left {
    @apply right-0;
  }

  &--right {
    @apply left-0;
  }

  .overlay-top {
    @apply flex items-stretch;
    @apply bg-almost-black border-b border-honestly-white p-2;
  }

  .item-list {
    @apply flex flex-col p-2;
    max-height: 350px;
    overflow-y: scroll;

    .item {
      @apply text-sm px-2 py-1;
      @apply bg-almost-black;
      @apply cursor-pointer;

      &:not(:last-child) {
        @apply mb-2;
      }

      &--selected {
        @apply bg-smurfs-gold text-honestly-white;
      }
    }
  }
}
</style>
